// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  api: {
    // baseUrl: 'https://api.rahaldeliveries.com'
    baseUrl: 'https://apitest.deliveryrahal.com'
    // baseUrl: 'https://api.deliveryrahal.com'
    // baseUrl: 'http://192.168.1.104:45455'
    // baseUrlWithoutAdmin: 'https://rahal-delivery.azurewebsites.net'
  },
  hubUrl: 'https://apitest.deliveryrahal.com/hubs/',
  // hubUrl: 'https://api.deliveryrahal.com/hubs/',
  // hubUrl: 'http://192.168.1.104:45455/hubs/',
  production: false,
  googleMaps: {
    apiKey: 'AIzaSyC1i1e2_Vrx-mWq_pwWZ2Mjtzu_12PdnsY', // Replace with your actual Google Maps API key
    mapId: 'YOUR_MAP_ID' // Optional: Replace with your map ID if you have one
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
